import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { faqs } from "@/data/content";

export const Faq = () => {
  return (
    <section id="ukk" className="py-16 sm:py-24 bg-[#F3EFE7]">
      <div className="max-w-3xl mx-auto px-6 sm:px-8">
        <div className="text-center">
          <span className="text-base font-bold text-[#245037] uppercase tracking-wide">
            Usein kysytyt kysymykset
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-[#1C1917]">
            Mietityttääkö jokin?
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-12 space-y-4">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="bg-white rounded-2xl border border-[#E8E2D5] px-6 shadow-sm"
            >
              <AccordionTrigger className="text-lg sm:text-xl font-bold text-[#1C1917] py-5 hover:no-underline [&>svg]:w-6 [&>svg]:h-6 [&>svg]:text-[#245037]">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-lg leading-relaxed text-[#44403C] pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
